import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";

import { FormInstance } from "antd/lib/form";
import { ICourtCaseConnectionType } from "../../model/CourtCaseConnectionType";

const FormFields = {
  ID: "id",
  NAME: "name",
  VALID: "valid"
};

const CourtCaseConnectionTypeForm = ({
  translate,
  form,
  rowData
}: {
  translate: any;
  form: FormInstance;
  rowData?: ICourtCaseConnectionType;
}) => {
  return (
    <Form layout={"vertical"} form={form}>
      <Form.Item
        style={{ display: "none" }}
        name={FormFields.ID}
        initialValue={rowData?.id ?? null}
      ></Form.Item>
      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.court_case_connection_type.name")}
            className={"mb-0"}
            name={FormFields.NAME}
            initialValue={rowData?.name}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_document_types.required_messages",
                  {
                    field: translate("editors.case_law_document_types.name")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={4}
          style={{
            display: "flex",
            marginTop: 20,
            alignItems: "center"
          }}
        >
          <Form.Item
            label={translate("editors.court_case_connection_type.valid")}
            className={"png-form-item-horizontal-checkbox mb-0"}
            name={FormFields.VALID}
            valuePropName={"checked"}
            initialValue={rowData?.valid ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CourtCaseConnectionTypeForm;
